export default __webpack_public_path__ + "0022a7135f3cd3800bc9ad3bff9571b8.png";